module.exports = __webpack_public_path__ + "img/eco friendly.c0422ced.jpg";